import { LOAD_CART, ADD_PRODUCT, REMOVE_PRODUCT,GET_RESTURENT_AVAILABILITY, GET_TIME_SLOTS, SET_TIME_SLOT, SET_TIME_SLOT_TIME, SET_DELIVERY_DATE  } from "./actionTypes";
import moment from 'moment'
import Axios from "axios";
import { GET_TIME_SLOTS_URL, CHECK_RESTURENT_AVAILABILITY } from "../../configs";

export const loadCart = (products) => ({
	type: LOAD_CART,
	payload: products,
});

export const addProduct = (product) => ({
	type: ADD_PRODUCT,
	payload: product,
});

export const removeProduct = (product) => (dispatch) => {

	return dispatch({ type: REMOVE_PRODUCT, payload: product });
};


export const getTimeSlots = () => (dispatch, getState) => {
	return Axios.get(GET_TIME_SLOTS_URL).then((response) => {
		const timeSlots = response.data;
		if (response.status === 200) {
			dispatch({ type: GET_TIME_SLOTS, payload: timeSlots });
		} else {
			return timeSlots;
		}
	})
		.catch(function (error) {
			return error.response;
		});
}



export const setTimeSlot = (value) => (dispatch, getState) => {
	return dispatch({ type: SET_TIME_SLOT, payload: value });
}

export const setTimeSlotTime = (value) => (dispatch, getState) => {
	return dispatch({ type: SET_TIME_SLOT_TIME, payload: value });
}

export const setDeliveryDate = (value) => (dispatch, getState) => {
	return dispatch({ type: SET_DELIVERY_DATE, payload: value });
}

export const checkResturentAvailability = (
	// user,
	date,
	time_slot_id,
	restaurant_id,
) => (dispatch, getState) => {
	return Axios.post(CHECK_RESTURENT_AVAILABILITY, {
		// token: user.data.auth_token,
		date: moment(date).format('DD-MM-YYYY'),
		time_slot_id: time_slot_id,
		restaurant_id: restaurant_id,
	})
		.then((response) => {
			const availability = response.data;
			console.log(availability)
			if (availability.success) {
				dispatch({ type: GET_RESTURENT_AVAILABILITY, payload: availability });
			} else {
				dispatch({ type: GET_RESTURENT_AVAILABILITY, payload: availability });
				return availability;
			}
		})
		.catch(function (error) {
			return error.response;
		});
};
